import { ReactElement } from 'react';
import InputCheckbox from '~/components/input/InputCheckbox';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TenantPackageAddOnTemplate } from '~/tenants/common/package';
import PerformableGroupForm, { usePerformableGroup } from '~/components/performable/PerformableGroupForm';
import BreAerialConfig, { BreAerialType } from '~/tenants/bre/performable/aerial/BreAerialConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';

export default function BreAerialAddOn({ persona }: { persona: PersonaType }): ReactElement {
  const group = usePerformableGroup();
  const added = group.hasPerformable(BreAerialConfig);

  return (
    <TenantPackageAddOnTemplate
      htmlFor="aerial"
      title="Aerial Upgrade"
      description="Add aerial video with 5 aerial photos included."
      image="tenant/bre/social/aerial.jpg"
      persona={persona}
      enable={
        <InputCheckbox
          id="aerial"
          checked={added}
          onChange={() => {
            if (added) {
              group.removePerformable(BreAerialConfig);
            } else {
              group.addPerformable(BreAerialConfig);
            }
          }}
        />
      }
    >
      {added && (
        <PerformableGroupForm performable={BreAerialConfig}>
          <ZodFieldHidden name="type" value={BreAerialType.COMBO} />
        </PerformableGroupForm>
      )}
    </TenantPackageAddOnTemplate>
  );
}
